export const routes = [
  {
    path: '/subGrupoIndicador',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'subGrupoIndicador.list'
  }
]
